import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { Truck, House, ListBullets, Receipt, Bell, UserCircle, SignOut, Lifebuoy } from "@phosphor-icons/react";

function NavItem({ to, label, icon: Icon, testid, end, badge }) {
  return (
    <NavLink to={to} end={end} data-testid={testid}
      className={({ isActive }) =>
        `flex-1 flex flex-col items-center justify-center gap-1 py-2 text-[10px] font-bold uppercase tracking-wider relative ${
          isActive ? "text-white" : "text-neutral-500"
        }`
      }>
      {({ isActive }) => (
        <>
          <div className={`p-1.5 rounded ${isActive ? "bg-red-600" : ""}`}>
            <Icon size={20} weight={isActive ? "fill" : "bold"} />
          </div>
          {label}
          {badge ? <span className="absolute top-0 right-1/4 bg-red-600 text-white text-[9px] font-bold rounded-full px-1.5 py-0.5">{badge > 9 ? "9+" : badge}</span> : null}
        </>
      )}
    </NavLink>
  );
}

export default function CustomerShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/notifications", { params: { limit: 1 } });
        if (alive) setUnread(data.unread || 0);
      } catch { /* swallow */ }
    };
    tick();
    const i = setInterval(tick, 30000);
    return () => { alive = false; clearInterval(i); };
  }, []);
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#0A0A0A", color: "#fff" }} data-testid="customer-portal-shell">
      <header className="px-4 py-3 flex items-center justify-between border-b border-neutral-800">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center"><img src="/logo.png?v=rf2026-newlogo-0804" alt="Roll Fast logo" className="w-8 h-8 object-contain" /></div>
          <div>
            <div className="label-tag text-neutral-500">Roll Fast · Customer</div>
            <div className="font-display font-bold leading-tight">{user?.name}</div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => nav("/support")} data-testid="customer-support-button" title="Support" aria-label="Support" className="text-neutral-400 p-2"><Lifebuoy size={20} weight="bold" /></button>
          <button onClick={() => nav("/customer/profile")} data-testid="customer-profile-button" className="text-neutral-400 p-2"><UserCircle size={22} weight="bold" /></button>
          <button onClick={async () => { await logout(); nav("/login"); }} data-testid="customer-logout-button" className="text-neutral-400 p-2"><SignOut size={20} weight="bold" /></button>
        </div>
      </header>
      <main id="main-content" tabIndex={-1} role="main" aria-label="Roll Fast customer content" className="flex-1 pb-24 overflow-x-hidden text-white" style={{ background: "#050505" }}><Outlet /></main>
      <nav className="fixed bottom-0 left-0 right-0 border-t border-neutral-800 flex" style={{ background: "#0A0A0A" }}>
        <NavItem to="/customer" label="Home" icon={House} testid="customer-nav-home" end />
        <NavItem to="/customer/loads" label="Loads" icon={ListBullets} testid="customer-nav-loads" />
        <NavItem to="/customer/invoices" label="Invoices" icon={Receipt} testid="customer-nav-invoices" />
        <NavItem to="/customer/notifications" label="Alerts" icon={Bell} testid="customer-nav-alerts" badge={unread} />
      </nav>
    </div>
  );
}
